import React, { FC, useMemo } from 'react'

import { ambassadorHttpClient } from '../../../api/httpClient'
import { BusinessTermService } from '../../reusable/Category/api/BusinessTermService'
import { Category as CategoryUnwrapped } from '../../reusable/Category/Category'

export const Category: FC = () => {
  const businessTermService = useMemo(() => new BusinessTermService(ambassadorHttpClient), [])
  return <CategoryUnwrapped businessTermService={businessTermService} />
}
